// extracted by mini-css-extract-plugin
export default {"button":"button-secondary_button__PUU8S","text":"button-secondary_text__D6jwg"};